var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-table", {
    attrs: {
      size: "small",
      "data-source": _vm.form.stockAdjustmentRows,
      columns: _vm.columns,
      pagination: {
        showSizeChanger: true,
        pageSizeOptions: _vm.PAGE_SIZE_OPTIONS,
        showTotal: function(total) {
          return _vm.$t("lbl_total_items", { total: total })
        }
      },
      "row-selection": {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange
      },
      "row-class-name": function(_record, index) {
        return index % 2 ? "bg-white" : "bg-gray-light"
      },
      scroll: { x: 1900 }
    },
    scopedSlots: _vm._u([
      {
        key: "nullable",
        fn: function(text) {
          return _c("span", {}, [_vm._v(_vm._s(text || "-"))])
        }
      },
      {
        key: "number",
        fn: function(text) {
          return _c("span", {}, [_vm._v(_vm._s(_vm._f("qty")(text)))])
        }
      },
      {
        key: "title",
        fn: function() {
          return [
            _c(
              "a-button-group",
              [
                _c("a-button", {
                  attrs: { icon: "plus", type: "primary" },
                  on: { click: _vm.addRow }
                }),
                _c("a-button", {
                  attrs: { icon: "delete", type: "danger" },
                  on: { click: _vm.handleDeleteRow }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "productCode",
        fn: function(text, row) {
          return [
            _c("SelectProductInventory", {
              staticClass: "w-100",
              attrs: {
                "warehouse-location-id": row.warehouseLocation
                  ? row.warehouseLocation.key
                  : undefined,
                "product-brand": _vm.form.brand,
                "product-category-id": _vm.form.productCategoryId,
                "use-serial-number": _vm.form.isUseSerialNumber
              },
              on: {
                "update:meta": function($event) {
                  return _vm.onChangeProduct($event, row)
                }
              },
              model: {
                value: row.productCode,
                callback: function($$v) {
                  _vm.$set(row, "productCode", $$v)
                },
                expression: "row.productCode"
              }
            })
          ]
        }
      },
      {
        key: "productName",
        fn: function(text, row) {
          return [
            _c("SelectProductInventory", {
              staticClass: "w-100",
              attrs: {
                "option-label": "name",
                "warehouse-location-id": row.warehouseLocation
                  ? row.warehouseLocation.key
                  : undefined,
                "product-brand": _vm.form.brand,
                "product-category-id": _vm.form.productCategoryId,
                "use-serial-number": _vm.form.isUseSerialNumber
              },
              on: {
                "update:meta": function($event) {
                  return _vm.onChangeProduct($event, row)
                }
              },
              model: {
                value: row.productName,
                callback: function($$v) {
                  _vm.$set(row, "productName", $$v)
                },
                expression: "row.productName"
              }
            })
          ]
        }
      },
      {
        key: "rack",
        fn: function(text, row) {
          return [
            _c("SelectRack", {
              staticClass: "w-100",
              attrs: {
                "warehouse-id": _vm.form.warehouse
                  ? _vm.form.warehouse.key
                  : "",
                "by-user": true,
                "value-as": "id"
              },
              on: {
                change: function($event) {
                  return _vm.onChangeRack(row)
                }
              },
              model: {
                value: row.warehouseLocation,
                callback: function($$v) {
                  _vm.$set(row, "warehouseLocation", $$v)
                },
                expression: "row.warehouseLocation"
              }
            })
          ]
        }
      },
      {
        key: "serialNumber",
        fn: function(text, row) {
          return [
            _c(
              "a-select",
              {
                staticClass: "w-100",
                attrs: {
                  loading: row.loadingSerialNumber,
                  placeholder: _vm.$t("common.select-text", {
                    text: _vm.$t("lbl_serial_number")
                  }),
                  "show-search": "",
                  "allow-clear": "",
                  "dropdown-match-select-width": false,
                  "option-label-prop": "label"
                },
                on: {
                  change: function($event) {
                    return _vm.onChangeSerialNumber(row, $event)
                  }
                },
                model: {
                  value: row.serialNumber,
                  callback: function($$v) {
                    _vm.$set(row, "serialNumber", $$v)
                  },
                  expression: "row.serialNumber"
                }
              },
              _vm._l(row.serialNumberOptions, function(option) {
                return _c(
                  "a-select-option",
                  {
                    key: option.key,
                    attrs: { value: option.value, label: option.label }
                  },
                  [
                    _c("a-tooltip", { attrs: { title: option.label } }, [
                      _vm._v(" " + _vm._s(option.label) + " ")
                    ])
                  ],
                  1
                )
              }),
              1
            )
          ]
        }
      },
      {
        key: "uom",
        fn: function(text, row) {
          return [
            _c("a-select", {
              staticClass: "w-100",
              attrs: {
                "allow-clear": "",
                "show-search": "",
                "label-in-value": "",
                placeholder: _vm.$t("common.select-text", {
                  text: _vm.$t("lbl_uom")
                }),
                options: row.uomOptions
              },
              model: {
                value: row.uom,
                callback: function($$v) {
                  _vm.$set(row, "uom", $$v)
                },
                expression: "row.uom"
              }
            })
          ]
        }
      },
      {
        key: "physicalQty",
        fn: function(text, row) {
          return [
            _c("a-input-number", {
              staticClass: "w-100",
              attrs: {
                formatter: _vm.formatterNumber,
                parser: _vm.reverseFormatNumber,
                precision: _vm.storeBaseDecimalPlace
              },
              model: {
                value: row.physicalQty,
                callback: function($$v) {
                  _vm.$set(row, "physicalQty", _vm._n($$v))
                },
                expression: "row.physicalQty"
              }
            })
          ]
        }
      },
      {
        key: "differenceQty",
        fn: function(text, row) {
          return [_c("span", [_vm._v(_vm._s(_vm.useCountQtyDifference(row)))])]
        }
      },
      {
        key: "notes",
        fn: function(text, row) {
          return [
            _c("a-input", {
              attrs: {
                maxlength: _vm.MAX_LENGTH_CHARACTER,
                placeholder: _vm.$t("common.insert-text", {
                  text: _vm.$t("lbl_note")
                }),
                "allow-clear": ""
              },
              model: {
                value: row.notes,
                callback: function($$v) {
                  _vm.$set(row, "notes", $$v)
                },
                expression: "row.notes"
              }
            }),
            _c("character-length", { attrs: { value: row.notes } })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }